:host {
  display: block;
}



.sportsline-analysis__analysis-text {
  color: var(--text-secondary-color);
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.3;
}

.sportsline-analysis__analysis-text-clamp {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
}

.sportsline-analysis__analysis-checkbox {
  display: none;
}

.sportsline-analysis__analysis-checkbox:checked ~ .sportsline-analysis__analysis-text {
  -webkit-line-clamp: unset;
  line-clamp: unset;
}

.sportsline-analysis__analysis-checkbox:checked ~ label .sportsline-analysis__analysis-toggle {
  display: none; 
}

.sportsline-analysis__analysis-toggle {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding-top: 8px;
  font-size: 18px;
  color: #888;
  transition: transform 0.3s ease;
}